import { NgModule } from '@angular/core';
import { SharedModule } from '../components/shared/shared.module';

// Pages Components
import { LoginPageComponent } from '../pages/login-page/login-page.component';
import { InitialPageComponent } from '../pages/initial-page/initial-page.component';
import { InitalPageDesktopComponent } from '../pages/initial-page/inital-page-desktop/inital-page-desktop.component';
import { InitalPageMobileComponent } from '../pages/initial-page/inital-page-mobile/inital-page-mobile.component';
import { SubmenuComponent } from '../pages/modals/submenu/submenu.component';
import { UpgradePlanComponent } from '../pages/upgrade-plan/upgrade-plan.component';

// Tester
import { TestComponent } from '../tester/test/test.component';

const PagesComponents = [
  LoginPageComponent,
  InitialPageComponent,
  InitalPageDesktopComponent,
  InitalPageMobileComponent,
  SubmenuComponent,
  UpgradePlanComponent,
  TestComponent
];

@NgModule({
  declarations: PagesComponents,
  imports: [SharedModule],
  exports: PagesComponents
})
export class PagesModule { }
